/**
 * 业绩与收益导航树 Mock 数据
 */
import type { NavTreeNode } from '@/types/common';
import { ROUTE_PATHS } from '@/utils/constants';

/** 业绩与收益导航树 */
export const performanceNavTree: NavTreeNode[] = [
  {
    id: 'performance-overview',
    label: '业绩总览',
    icon: 'dashboard',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'overview',
        label: '业绩看板',
        icon: 'dashboard',
        route: ROUTE_PATHS.PERFORMANCE_OVERVIEW,
      },
      {
        id: 'trends',
        label: '业绩趋势',
        icon: 'dashboard',
        route: ROUTE_PATHS.PERFORMANCE_TRENDS,
      },
      {
        id: 'target-achievement',
        label: '目标达成',
        icon: 'dashboard',
        route: ROUTE_PATHS.PERFORMANCE_TARGET_ACHIEVEMENT,
      },
    ],
  },
  {
    id: 'commission-management',
    label: '分润管理',
    icon: 'account_balance_wallet',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'commission-details',
        label: '分润明细',
        icon: 'account_balance_wallet',
        route: ROUTE_PATHS.PERFORMANCE_COMMISSION_DETAILS,
      },
      {
        id: 'commission-settlement',
        label: '分润结算',
        icon: 'account_balance_wallet',
        route: ROUTE_PATHS.PERFORMANCE_COMMISSION_SETTLEMENT,
      },
      {
        id: 'commission-report',
        label: '分润报表',
        icon: 'account_balance_wallet',
        route: ROUTE_PATHS.PERFORMANCE_COMMISSION_REPORT,
      },
    ],
  },
  {
    id: 'reward-incentive',
    label: '奖励激励',
    icon: 'emoji_events',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'reward-policy',
        label: '奖励政策',
        icon: 'emoji_events',
        route: ROUTE_PATHS.PERFORMANCE_REWARD_POLICY,
      },
      {
        id: 'reward-details',
        label: '奖励明细',
        icon: 'emoji_events',
        route: ROUTE_PATHS.PERFORMANCE_REWARD_DETAILS,
      },
      {
        id: 'reward-ranking',
        label: '奖励排行',
        icon: 'emoji_events',
        route: ROUTE_PATHS.PERFORMANCE_REWARD_RANKING,
      },
    ],
  },
  {
    id: 'data-analysis',
    label: '数据分析',
    icon: 'analytics',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'project-analysis',
        label: '项目分析',
        icon: 'analytics',
        route: ROUTE_PATHS.PERFORMANCE_PROJECT_ANALYSIS,
      },
      {
        id: 'customer-analysis',
        label: '客户分析',
        icon: 'analytics',
        route: ROUTE_PATHS.PERFORMANCE_CUSTOMER_ANALYSIS,
      },
      {
        id: 'region-analysis',
        label: '区域分析',
        icon: 'analytics',
        route: ROUTE_PATHS.PERFORMANCE_REGION_ANALYSIS,
      },
    ],
  },
];
